import { render } from "./HowItWorksValueComponent.vue?vue&type=template&id=7d40e4d0"
import script from "./HowItWorksValueComponent.vue?vue&type=script&lang=js"
export * from "./HowItWorksValueComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__